import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import * as React from 'react';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import Author from './author';
import Header from './header';
import ReviewBody from './body';
var breakpointSm = '@media screen and (max-width: 650px)';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   padding: 32px 18px 0;\n   border-bottom: ", ";\n\n   ", " {\n      padding: 32px 0;\n   }\n"])), function (props) {
  return props.showBorder && '1px solid' + color.gray[200];
}, breakpointSm);

var Review = function Review(_ref) {
  var review = _ref.review,
      showBorder = _ref.showBorder,
      locale = _ref.locale,
      reviewsUrl = _ref.reviewsUrl;
  var rating = review.rating,
      headline = review.headline,
      body = review.body,
      author = review.author,
      created_date = review.created_date,
      productName = review.productName,
      productVariantName = review.productVariantName;
  var date = new Date(created_date * 1000).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  var body_trunc = body.substring(0, 300);
  return /*#__PURE__*/React.createElement(Container, {
    showBorder: showBorder
  }, /*#__PURE__*/React.createElement(Author, {
    author: author,
    reviewsUrl: reviewsUrl
  }), /*#__PURE__*/React.createElement(Header, {
    rating: rating,
    headline: headline,
    date: date,
    productName: productName,
    productVariantName: productVariantName
  }), /*#__PURE__*/React.createElement(ReviewBody, {
    body: body,
    body_trunc: body_trunc
  }));
};

export default Review;